import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <section
      className={cn(
        "bg-white border border-[#e8ebf0] rounded-xl overflow-hidden shadow-[0_1px_2px_rgba(8,37,76,0.04)]",
        className,
      )}
    >
      {children}
    </section>
  );
}

export function CardHead({
  overline,
  title,
  actions,
  right,
}: {
  overline?: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="px-5 py-4 flex justify-between items-center gap-3 border-b border-[#f2f4f7]">
      <div className="flex flex-col gap-0.5">
        {overline && (
          <div className="font-mono text-[10px] text-[#596b85] tracking-[0.18em] uppercase font-semibold">
            {overline}
          </div>
        )}
        <h3 className="font-brand font-bold text-base text-[#08254c] m-0 tracking-[-0.01em]">{title}</h3>
      </div>
      <div className="flex gap-1.5 items-center">
        {actions}
        {right}
      </div>
    </div>
  );
}

export function SectionHead({
  overline,
  title,
  tag,
  sub,
  right,
}: {
  overline?: ReactNode;
  title: ReactNode;
  tag?: ReactNode;
  sub?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="flex items-end justify-between gap-5 mb-4 flex-wrap">
      <div>
        {overline && (
          <div className="font-mono text-[10px] text-[#ffc83d] tracking-[0.22em] uppercase font-semibold mb-1.5">
            {overline}
          </div>
        )}
        <h2 className="font-brand font-bold text-[22px] text-[#08254c] m-0 tracking-[-0.015em] flex items-center gap-3">
          {title}
          {tag && (
            <span
              className="font-mono text-[10px] font-semibold px-2.5 py-1 rounded-full uppercase tracking-[0.08em]"
              style={{
                background: "rgba(255,200,61,0.12)",
                color: "#8a6200",
                border: "1px solid rgba(255,200,61,0.3)",
              }}
            >
              {tag}
            </span>
          )}
        </h2>
        {sub && <div className="text-[13px] text-[#596b85] mt-1 max-w-[640px]">{sub}</div>}
      </div>
      {right && <div className="flex gap-3 items-center flex-wrap">{right}</div>}
    </div>
  );
}

export function Mantra({ children }: { children: ReactNode }) {
  return (
    <div className="text-center font-mono text-[10px] text-[#7b8799] tracking-[0.22em] py-3 pb-8 uppercase">
      {children}
    </div>
  );
}

export function MantraAccent({ children }: { children: ReactNode }) {
  return <span className="text-[#ffc83d]">{children}</span>;
}
